const NotFound = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1663 14.667H11.1663M13.833 20.0003H11.1663M21.833 9.33366H11.1663M27.1663 16.0003V9.06699C27.1663 6.82678 27.1663 5.70668 26.7304 4.85103C26.3469 4.09838 25.7349 3.48646 24.9823 3.10297C24.1267 2.66699 23.0066 2.66699 20.7663 2.66699H12.233C9.9928 2.66699 8.87269 2.66699 8.01705 3.10297C7.2644 3.48646 6.65248 4.09838 6.26898 4.85103C5.83301 5.70668 5.83301 6.82678 5.83301 9.06699V22.9337C5.83301 25.1739 5.83301 26.294 6.26898 27.1496C6.65248 27.9023 7.2644 28.5142 8.01705 28.8977C8.87269 29.3337 9.9928 29.3337 12.233 29.3337H16.4997M21.833 21.3337L28.4997 28.0003M28.4997 21.3337L21.833 28.0003"
      stroke="#4C1D95"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NotFound;
